exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// /home/runner/work/slipresistant/slipresistant/client/~/babel-polyfill/~/core-js/modules/_object-pie.js
// module id = VvJf
// module chunks = 0 3